import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMenu1 = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "35px",
	viewBox: "0 0 24 35",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		fontFamily: "Raleway-Medium, Raleway",
		fontSize: 60,
		fontWeight: 400,
		children: /* @__PURE__ */ _jsx("g", {
			id: "Satzbau-&-Wortschatz-\\u2013-noch-nichts-bewertet",
			transform: "translate(-22.000000, -216.000000)",
			fill: "#FFFFFF",
			children: /* @__PURE__ */ _jsx("text", {
				id: 1,
				children: /* @__PURE__ */ _jsx("tspan", {
					x: 20,
					y: 251,
					children: "1"
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconMenu1);
export { ForwardRef as ReactComponent };
